import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const ArchiveFileIcon = createSvgIcon(
  <g>
    <rect x="8" y="8" width="48" height="48" rx="10" fill="#78716C" />
    <text
      x="32"
      y="40"
      textAnchor="middle"
      fill="#FFFFFF"
      fontFamily="Inter, ui-sans-serif, system-ui, sans-serif"
      fontSize="14"
      fontWeight="800"
    >
      ZIP
    </text>
  </g>,
  'ArchiveFileIcon',
);
